import { createTheme } from "@mui/material";
import { enUS as coreEnUS, plPL as corePlPL } from "@mui/material/locale";
import {
  enUS as datePickerEnUS,
  plPL as datePickerPlPL,
} from "@mui/x-date-pickers/locales";

import components from "./Components";
import breakpoints from "./Modules/breakpointsModule";
import palette from "./Modules/paletteModule";
import typography from "./Modules/typographyModule";

export const theme = ({ language }: { language: string }) =>
  createTheme(
    {
      palette,
      components,
      typography,
      breakpoints,
    },
    language === "en" ? datePickerEnUS : datePickerPlPL, // datepicker translations
    language === "en" ? coreEnUS : corePlPL // core translations
  );

export const themeOptions = () => ({
  palette,
  components,
  typography,
});
